module.exports = __webpack_public_path__ + "img/code-empty.6757ab63.png";